import { Skeleton } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { NavBar } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { AppSubNav } from "@src/components/widgets/AppSubNav/AppSubNav";
import { useCreditAccountDetailNavigation } from "@src/components/widgets/AppSubNav/navigation-credit-accounts/hooks";
import { useScreenType } from "@src/utils/hooks/useIsMobile";

type NavigationCreditAccountDetailProps = {
  creditAccountId: string;
};
export const NavigationCreditAccountDetail = ({
  creditAccountId,
}: NavigationCreditAccountDetailProps) => {
  const { visiblePages, isLoading, data } =
    useCreditAccountDetailNavigation(creditAccountId);
  const { isDesktop } = useScreenType();

  return (
    <AppSubNav>
      {visiblePages.map((page) => (
        <NavBar.Item key={page.href.pathname} href={page.href} active={false}>
          {page.title()}
        </NavBar.Item>
      ))}

      {isDesktop && <Icon name="chevron-right" />}

      <NavBar.Item
        href={{
          pathname: "/credit-accounts/detail",
          query: {
            id: creditAccountId,
          },
        }}
        active={false}
      >
        <Skeleton isLoaded={!isLoading}>
          {data?.title ?? <Trans>Detail</Trans>}
        </Skeleton>
      </NavBar.Item>
    </AppSubNav>
  );
};
